var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineUpSoccerGoalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3946_499487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5C13.6953 17.5 17.5 13.6953 17.5 9C17.5 4.30577 13.6954 0.5 9 0.5C4.30572 0.5 0.5 4.30572 0.5 9C0.5 13.6954 4.30577 17.5 9 17.5Z",
    fill: "#D2DADE",
    stroke: "#14171F",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.9896C10.5808 16.9896 12.0496 16.5245 13.2912 15.733C10.6789 16.3645 7.84266 15.7234 5.70933 13.8248C2.5872 11.0653 1.8512 6.42211 3.96213 2.80078C3.3008 3.34585 2.7344 3.97838 2.27147 4.67278C2.26613 4.68131 2.2608 4.69091 2.25547 4.70051C2.10613 4.92345 1.98453 5.16345 1.85867 5.39918C1.3136 6.47971 1 7.69678 1 8.98958C1 13.4088 4.58187 16.9896 9 16.9896",
    fill: "#929DA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2895 4.07227L13.5892 3.0952L11.3364 1.35547C12.9215 1.8376 14.2911 2.80187 15.2895 4.07227ZM8.06679 2.16951L7.52066 4.00205L4.44226 5.83351L3.35106 4.85218L4.76226 3.11885L6.43052 2.16951H8.06679ZM1.37347 11.4187C1.19854 10.8683 1.08547 10.2902 1.0332 9.69394L1.718 7.45501V10.3339L1.37347 11.4187ZM16.6662 11.273C16.8796 10.5509 16.999 9.78819 16.999 8.99779C16.999 8.72152 16.9841 8.44632 16.9574 8.17646L16.6662 9.19086V11.273ZM9.61375 15.4091L9.86549 16.9537C11.7322 16.7531 13.4058 15.9137 14.6634 14.655L12.6292 13.7089L9.61375 15.4091ZM9.99725 5.59999L9.51512 9.00159L12.5946 10.6368L14.8709 8.28159L13.2346 5.10933L9.99725 5.59999ZM6.72671 13.8333V10.6269L4.00031 8.82846L2.55711 11.2487L4.32031 14.389L6.72671 13.8333Z",
    fill: "#14171F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3946_499487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineUpSoccerGoalIcon);
export default __webpack_public_path__ + "static/media/line_up_soccer_goal_icon.e3e25f1a13b9bf3d740ff6563618802b.svg";
export { ForwardRef as ReactComponent };